import styled from 'styled-components';

import Container from '../Container.styled';

export const HeaderStyled = styled(Container)`
  position: relative;
  display: flex;
  justify-content: space-between;
  padding: 15px 60px;

  ${({ theme }) => `
    background-color: ${theme.headerColour};

    ${theme.devices.touch} {
      padding: 15px 20px;
    }
  `}
`;

export const NavStyled = styled.nav`
  display: flex;
  gap: 15px;

  ${({ theme }) => `
    .navbar-item {
      color: ${theme.textColour};
    }

    .tel-link {
      color: ${theme.primaryColour};
    }

    ${theme.devices.touch} {
      display: none;
    }
  `}
`;

export const LogoLinkStyled = styled.a`
  display: inline-flex;
  flex-direction: column;
  justify-content: center;
`;

export const LogoStyled = styled.img`
  max-height: 60px;
`;

export const BurgerButtonStyled = styled.button`
  display: none;

  ${({ theme }) => `
      ${theme.devices.touch} {
        display: block;
      }
    `}
`;

export const OptionalSupSectionStyled = styled.div`
  ${({ theme }) => `
      ${theme.devices.touch} {
        display: none;
      }
    `}
`;

export const MobileNavStyled = styled.nav`
  position: absolute;
  left: 0;
  right: 0;
  z-index: 2;

  ${({ theme }) => `
    background: ${theme.headerColour};
  `}
`;
